/* istanbul ignore file */

import Vue from "vue";

import toasted from "vue-toasted";
import Fragment from "vue-fragment";

import store from "../store";
import directives from "../directives";
import { mapGetters } from "vuex";

import "../filters";
import "../axios";

import AbilityWrapper from "../components/AbilityWrapper";
import AdultContentSwitcher from "../components/AdultContentSwitcher";
import AdultContentWarning from "../components/AdultContentWarning";
import Alert from "../components/Alert";
import AsyncForm from "../components/FormsAsyncForm";
import Badge from "../components/Badge";
import BadgeGroup from "../components/BadgeGroup";
import ButtonCheckout from "../components/CheckoutButtonCheckout";
import ButtonCheckoutConfirm from "../components/CheckoutButtonCheckoutConfirm";
import CacheableForm from "../components/FormsCacheableForm";
import Carousel from "../components/Carousel";
import CashbackPrice from "../components/CashbackPrice";
import CreditCards from "../components/CheckoutPaymentsStripeCreditCards";
import EssentialsCartOverlay from "../components/EssentialsCartOverlay";
import EssentialsLists from "../components/EssentialsLists";
import EssentialsVendorFilterModal from "../components/EssentialsVendorFilterModal";
import EssentialsVendorFilterSelector from "../components/EssentialsVendorFilterSelector";
import ExpandButton from "../components/ExpandButton";
import FAQItem from "../components/FAQItem";
import FetcherProductShow from "../components/FetcherProductShow";
import FilterProductSearch from "../components/FilterProductSearch";
import FlashMessages from "../components/FlashMessages";
import FormRecaptcha from "../components/FormRecaptcha";
import GenericStripePayment from "../components/CheckoutPaymentsStripeGenericPayment";
import GoogleMapStatic from "../components/GoogleMapStatic";
import IconTeaser from "../components/IconTeaser";
import IdealoCookieSetter from "../components/IdealoCookieSetter";
import ListWrapper from "../components/CampaignsListWrapper";
import LunchMenuView from "../components/LunchMenuView";
import LunchCheckIn from "../components/LunchCheckIn";
import ManagementBar from "../components/ManagementBar";
import MobileMenuContent from "../components/MobileMenuContent";
import MobileMenuToggle from "../components/MobileMenuToggle";
import Modal from "../components/Modal";
import OnboardingLoadingOverlay from "../components/OnboardingLoadingOverlay";
import OnboardingSignupForm from "../components/OnboardingSignupForm";
import OtherVendors from "../components/OtherVendors";
import OtherVendorsModal from "../components/OtherVendorsModal";
import PasswordStrengthMeter from "../components/PasswordStrengthMeter";
import PaymentButtonWrapper from "../components/CheckoutPaymentButtonWrapper";
import PaymentsWrapper from "../components/CheckoutPaymentsWrapper";
import PaymentWrapper from "../components/CheckoutPaymentWrapper";
import PaypalPlus from "../components/CheckoutPaymentsPayPalPlus";
import PortalVue from "portal-vue";
import PricingToggler from "../components/PricingToggler";
import ProductEssentialItem from "../components/ProductEssentialItem";
import ProductGallery from "../components/ProductGallery";
import ProductHiddenField from "../components/VariantPickerProductHiddenField";
import ProductNameFilterInput from "../components/CampaignsProductNameFilterInput";
import ProductQuickEditButtons from "../components/ProductQuickEditButtons";
import ProductTile from "../components/ProductTile";
import ProductTileWrapper from "../components/ProductTileWrapper";
import ReadMore from "../components/ReadMore";
import SavingsBadge from "../components/ProductSavingsBadge";
import Searchbar from "../components/Searchbar";
import SearchbarAutocomplete from "../components/SearchbarAutocomplete";
import ServiceTile from "../components/ServiceTile";
import ShoppingCartButton from "../components/ShoppingCartButton";
import ShoppingCartOverlay from "../components/ShoppingCartOverlay";
import ShoppingList_Cart from "../components/ShoppingListCart";
import ShoppingList_Item from "../components/ShoppingListItem";
import ShoppingListModalContent from "../components/ShoppingListModalContent";
import ShoppingListVisibilityWrapper from "../components/ShoppingListVisibilityWrapper";
import SocialSharing from "vue-social-sharing";
import StoreJoinTab from "../components/MitmachenJoinTab";
import StoreJoinTabs from "../components/MitmachenJoinTabs";
import StripeScriptLoader from "../components/CheckoutPaymentsStripeScriptLoader";
import SubmitButton from "../components/VariantPickerSubmitButton";
import Swiper from "../components/Swiper";
import TabContent from "../components/TabContent";
import TabContentWrapper from "../components/TabContentWrapper";
import TabNav from "../components/TabNav";
import TabNavItem from "../components/TabNavItem";
import UserFormEmailField from "../components/UserFormEmailField";
import UserFormSubmitButton from "../components/UserFormSubmitButton";
import VariantPicker from "../components/VariantPicker";
import VariantPrice from "../components/VariantPrice";
import VendorIntroButton from "../components/VendorIntroButton";
import VendorIntroVideo from "../components/VendorIntroVideo";
import VendorList from "../components/VendorList";
import VendorLocation from "../components/VendorLocation";
import VendorNavigation from "../components/VendorNavigation";
import VendorTile from "../components/VendorTile";
import VoucherCodeInput from "../components/CheckoutVoucherCodeInput";
import WishlistButton from "../components/WishlistButton";
import Zoomer from "../components/Zoomer";

const vueEl = "[data-vue-global='frontend']";

Vue.directive("open-modal", directives.openModal);
Vue.directive("close-modal", directives.closeModal);
Vue.directive("toggle", directives.toggle);

const currentCityElement = document.querySelector("[data-current-city]");
const currentLocaleElement = document.querySelector("[data-current-locale]");

document.ready.then(() => {
  Vue.use(toasted, {
    containerClass: "ata-toast",
    iconPack: "fontawesome",
    duration: 5000,
  });

  Vue.use(Fragment.Plugin);
  Vue.use(SocialSharing);
  Vue.use(PortalVue);

  if (document.querySelector(vueEl)) {
    if (currentCityElement) {
      store.dispatch("setCurrentCityUrl", currentCityElement.getAttribute("data-current-city"));
    }
    if (currentLocaleElement) {
      store.dispatch("setCurrentLocale", currentLocaleElement.getAttribute("data-current-locale"));
    }
    document.querySelectorAll(vueEl).forEach(element => {
      new Vue({
        el: element,
        store,
        name: "Frontend",
        components: {
          "ability-wrapper": AbilityWrapper,
          "adult-content-switcher": AdultContentSwitcher,
          "adult-content-warning": AdultContentWarning,
          "async-form": AsyncForm,
          "badge-group": BadgeGroup,
          "button-checkout-confirm": ButtonCheckoutConfirm,
          "button-checkout": ButtonCheckout,
          "cacheable-form": CacheableForm,
          "essentials-cart-overlay": EssentialsCartOverlay,
          "essentials-lists": EssentialsLists,
          "essentials-vendor-filter-modal": EssentialsVendorFilterModal,
          "essentials-vendor-filter-selector": EssentialsVendorFilterSelector,
          "expand-button": ExpandButton,
          "faq-item": FAQItem,
          "fetcher-product-show": FetcherProductShow,
          "filter-product-search": FilterProductSearch,
          "flash-messages": FlashMessages,
          "form-recaptcha": FormRecaptcha,
          "google-map-static": GoogleMapStatic,
          "icon-teaser": IconTeaser,
          "idealo-cookie-setter": IdealoCookieSetter,
          "list-wrapper": ListWrapper,
          "lunch-menu-view": LunchMenuView,
          "lunch-check-in": LunchCheckIn,
          "management-bar": ManagementBar,
          "mobile-menu-content": MobileMenuContent,
          "mobile-menu-toggle": MobileMenuToggle,
          "onboarding-loading-overlay": OnboardingLoadingOverlay,
          "onboarding-signup-form": OnboardingSignupForm,
          "other-vendors-modal": OtherVendorsModal,
          "other-vendors": OtherVendors,
          "password-strength-meter": PasswordStrengthMeter,
          "payment-button-wrapper": PaymentButtonWrapper,
          "payment-credit-card": CreditCards,
          "payment-paypal-plus": PaypalPlus,
          "payment-stripe-generic": GenericStripePayment,
          "payment-wrapper": PaymentWrapper,
          "payments-wrapper": PaymentsWrapper,
          "pricing-toggler": PricingToggler,
          "product-essential-item": ProductEssentialItem,
          "product-name-filter-input": ProductNameFilterInput,
          "product-quick-edit-buttons": ProductQuickEditButtons,
          "product-tile-wrapper": ProductTileWrapper,
          "product-tile": ProductTile,
          "read-more": ReadMore,
          "searchbar-autocomplete": SearchbarAutocomplete,
          "service-tile": ServiceTile,
          "shopping-cart-button": ShoppingCartButton,
          "shopping-cart-overlay": ShoppingCartOverlay,
          "shopping-list-modal-content": ShoppingListModalContent,
          "shopping-list-visibility-wrapper": ShoppingListVisibilityWrapper,
          "store-cashback-price": CashbackPrice,
          "store-join-tab": StoreJoinTab,
          "store-join-tabs": StoreJoinTabs,
          "store-product-gallery": ProductGallery,
          "store-product-hidden-field": ProductHiddenField,
          "store-savings-badge": SavingsBadge,
          "store-shopping-list-cart": ShoppingList_Cart,
          "store-shopping-list-item": ShoppingList_Item,
          "store-submit-button": SubmitButton,
          "store-swiper": Swiper,
          "store-variant-picker": VariantPicker,
          "store-variant-price": VariantPrice,
          "store-vendor-intro-button": VendorIntroButton,
          "store-vendor-intro-video": VendorIntroVideo,
          "store-zoomer": Zoomer,
          "stripe-script-loader": StripeScriptLoader,
          "tab-content-wrapper": TabContentWrapper,
          "tab-content": TabContent,
          "tab-nav-item": TabNavItem,
          "tab-nav": TabNav,
          "user-form-email-field": UserFormEmailField,
          "user-form-submit-button": UserFormSubmitButton,
          "vendor-list": VendorList,
          "vendor-location": VendorLocation,
          "vendor-navigation": VendorNavigation,
          "vendor-tile": VendorTile,
          "voucher-code-input": VoucherCodeInput,
          "wishlist-button": WishlistButton,
          alert: Alert,
          badge: Badge,
          carousel: Carousel,
          modal: Modal,
          searchbar: Searchbar,
        },
        computed: {
          ...mapGetters({ toggles: "getGlobalToggles" }),
        },
        mounted() {
          window._lytics_.attachEventListeners(this.$el);
        },
      });
    });
  }
});
